<script setup>
import { useForm } from '@inertiajs/vue3'
import AuthLayout from '@/Layouts/AuthLayout.vue'
import UiButton from '@/Components/UI/UiButton.vue'

defineProps({
  errors: { type: Object, default: () => ({}) },
})

const form = useForm({
  email: '',
  password: '',
  remember_me: false,
})

function submit() {
  form.transform((data) => ({ user: data })).post('/users/sign_in')
}
</script>

<template>
  <AuthLayout title="Sign in to your account">
    <div
      v-if="errors.base"
      class="mb-4 rounded-[var(--radius-md)] p-3 text-sm"
      :style="{ background: 'var(--dangerSoft)', border: '1px solid color-mix(in oklab, var(--danger) 35%, transparent)', color: 'var(--danger)' }"
    >
      {{ errors.base[0] }}
    </div>

    <form @submit.prevent="submit" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">Email</label>
        <input
          v-model="form.email"
          type="email"
          required
          autocomplete="email"
          class="w-full border rounded-[var(--radius-md)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]"
          :class="form.errors.email ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)]'"
        />
        <p v-if="form.errors.email" class="mt-1 text-xs text-[color:var(--danger)]">{{ form.errors.email }}</p>
      </div>

      <div>
        <label class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">Password</label>
        <input
          v-model="form.password"
          type="password"
          required
          autocomplete="current-password"
          class="w-full border border-[color:var(--line)] rounded-[var(--radius-md)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]"
        />
      </div>

      <div class="flex items-center justify-between">
        <label class="flex items-center gap-2 text-sm text-[color:var(--inkSoft)]">
          <input v-model="form.remember_me" type="checkbox" class="rounded" />
          Remember me
        </label>
        <a href="/users/password/new" class="text-sm text-[color:var(--accent)] hover:underline">
          Forgot password?
        </a>
      </div>

      <UiButton
        type="submit"
        variant="primary"
        :loading="form.processing"
        class="w-full justify-center"
      >
        {{ form.processing ? 'Signing in…' : 'Sign in' }}
      </UiButton>
    </form>
  </AuthLayout>
</template>
